import React = require('react');
import { Col, Row } from 'react-bootstrap';
import { Field, InjectedFormProps } from 'redux-form';
import PostcodeControl from '../../components/PostcodeControl';
import FieldFormControl from '../../components/FieldFormControl';
import {
  doesNotStartWith,
  hasEmojis,
  hasSpecialCharactersWithNumbers,
  isNotLongerThan,
  isPostcode,
  isRequired
} from '../../util/validators';
import { useEffect, useState } from 'react';
import { IChannel, IPostcodeAddress, ITraveller } from '../../data/api/models';
import { get, head } from 'lodash';

interface IPostcodeLookupProps extends InjectedFormProps {
  travellers: ITraveller[];
  channel: IChannel;
  basePath: string;
  title: string;
  showManualEntry?: boolean;
}

export const PostcodeLookup = ({
                                 change,
                                 basePath,
                                 travellers,
                                 channel,
                                 title,
                                 showManualEntry = false
                               }: IPostcodeLookupProps) => {

  const [showAddressField, setShowAddressField] = useState(false);
  const leadTraveller: ITraveller = head(travellers);

  const postcodeValidators = [
    isRequired,
    isPostcode,
    hasEmojis,
    isNotLongerThan(8)
  ];

  useEffect(() => {
    if (get(leadTraveller, 'address.line1')) {
      setShowAddressField(true);
    }
  }, [leadTraveller]);

  if (channel.channelType === 'AGG') {
    postcodeValidators.push(doesNotStartWith(
      ['JE', 'GY', 'GX'],
      true,
      'We cannot provide cover for your area.',
    ));
  }

  const handleSelectAddress = (address: IPostcodeAddress) => {

    change(`${basePath}.line1`, get(address, 'line1', ''));
    change(`${basePath}.line2`, get(address, 'line2', ''));
    change(`${basePath}.town`, get(address, 'town', ''));
    change(`${basePath}.county`, get(address, 'county', ''));
    change(`${basePath}.postcode`, get(address, 'postcode', ''));
    setShowAddressField(true);
  }

  const handleSearchComplete = (showAddress) => {
    setShowAddressField(showAddress);
  }

  const handleClearAddress = () => {
    handleSelectAddress(null);
  }

  const handleShowAddress = () => {
    setShowAddressField(true);
  }

  return (
    <>
      <Row className={'adm-form-group'}>
        <Col xs={6} className={'full-width-xs'}>{title}</Col>
        <Col xs={6} className={'full-width-xs'}>
          <Field
            autocomplete="new-password"
            name={`${basePath}.postcode`}
            type="text"
            component={PostcodeControl}
            onSearchComplete={handleSearchComplete}
            onSelectAddress={handleSelectAddress}
            onClearAddress={handleClearAddress}
            onManualEntry={handleShowAddress}
            showManualEntry={showManualEntry}
            validate={postcodeValidators}
          />
        </Col>
      </Row>
      {showAddressField && (
        <Row className={'adm-form-group'}>
          <Col xs={6} className="full-width-xs">{'Traveller Address'}</Col>
          <Col xs={6} className="full-width-xs">
            <Field
              autocomplete="new-password"
              className="line-top"
              name={`${basePath}.line1`}
              placeholder="Line 1"
              type="text"
              component={FieldFormControl}
              validate={[
                isRequired,
                hasEmojis,
                hasSpecialCharactersWithNumbers
              ]}
            />
            <Field
              autocomplete="new-password"
              className="line-middle"
              name={`${basePath}.line2`}
              placeholder="Line 2"
              type="text"
              component={FieldFormControl}
              validate={[
                hasEmojis,
                hasSpecialCharactersWithNumbers,
              ]}
            />
            <Field
              autocomplete="new-password"
              className="line-middle"
              name={`${basePath}.town`}
              type="text"
              placeholder="Town"
              component={FieldFormControl}
              validate={[
                isRequired,
                hasEmojis,
                hasSpecialCharactersWithNumbers
              ]}
            />
            <Field
              autocomplete="new-password"
              className="line-bottom"
              name={`${basePath}.county`}
              placeholder="County"
              type="text"
              component={FieldFormControl}
              validate={[
                hasEmojis,
                hasSpecialCharactersWithNumbers
              ]}
            />
          </Col>
        </Row>
      )}

    </>
  )
}
